type TrackingCleanup = () => void;

export class ActiveElementTracker {
  private cleanup: TrackingCleanup | null = null;
  private isTracking = false;
  private observer: MutationObserver | null = null;
  private focusInHandler: ((e: FocusEvent) => void) | null = null;

  start(): void {
    if (this.isTracking) {
      console.warn('Active element tracking is already running');
      return;
    }

    let previousActiveElement = document.activeElement;

    this.observer = new MutationObserver(() => {
      const currentActiveElement = document.activeElement;

      if (currentActiveElement !== previousActiveElement) {
        console.log('Active element changed:', {
          from: previousActiveElement,
          to: currentActiveElement,
          tagName: currentActiveElement?.tagName,
          id: currentActiveElement?.id,
          className: currentActiveElement?.className,
          timestamp: new Date().toISOString(),
        });

        previousActiveElement = currentActiveElement;
      }
    });

    // Lyssna på förändringar i hela dokumentet
    this.observer.observe(document, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['tabindex'],
    });

    this.focusInHandler = (e: FocusEvent) => {
      console.log('Focus in:', e.target);
    };

    // Lyssna också på focus/blur events för säkerhets skull
    document.addEventListener('focusin', this.focusInHandler);

    this.isTracking = true;
    console.log('Active element tracking started');
  }

  stop(): void {
    if (!this.isTracking) {
      console.warn('Active element tracking is not running');
      return;
    }

    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }

    if (this.focusInHandler) {
      document.removeEventListener('focusin', this.focusInHandler);
      this.focusInHandler = null;
    }

    this.isTracking = false;
    console.log('Active element tracking stopped');
  }

  toggle(): void {
    if (this.isTracking) {
      this.stop();
    } else {
      this.start();
    }
  }

  getStatus(): boolean {
    return this.isTracking;
  }
}

export const activeElementTracker = new ActiveElementTracker();

export function trackActiveElement(): TrackingCleanup {
  const tracker = new ActiveElementTracker();
  tracker.start();
  return () => tracker.stop();
}
